import { AutoForm } from '@tunasong/ui-lib'
import { graphHooks } from '@tunasong/graph-lib/react'
import type { LayoutComponent } from '@tunasong/plugin-lib'
import type { Entity } from '@tunasong/schemas'
import type { FC } from 'react'
import { useCallback } from 'react'

/** Default view for entities with schema */
const SchemaView: FC<LayoutComponent<Entity>> = props => {
  const { entity, schema } = props

  const updateEntity = graphHooks.useEntityUpdate({ debounceDelay: 1000 })
  const handleUpdate = useCallback(
    (e: Record<string, unknown>) => updateEntity(entity.id, e),
    [entity.id, updateEntity]
  )

  return schema ? <AutoForm schema={schema} defaultValues={entity} onSubmit={handleUpdate} /> : null
}

export default SchemaView
